import { render, staticRenderFns } from "./PublishBody.vue?vue&type=template&id=a8b0f352&scoped=true&"
import script from "./PublishBody.vue?vue&type=script&lang=js&"
export * from "./PublishBody.vue?vue&type=script&lang=js&"
import style0 from "./PublishBody.vue?vue&type=style&index=0&id=a8b0f352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b0f352",
  null
  
)

export default component.exports